import React, { useState } from 'react'
import { trackEvent } from '../../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../../context/MatchScreenContext'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { MODULE_KEYS, CSAT_DEFAULTS } from '../../moduleRegistry'
import { CsatTextarea } from './CsatTextarea'
import '../../styles/CsatModule/CsatModule.scss'

const RATINGS = [1, 2, 3, 4, 5] as const
type Rating = typeof RATINGS[number]

export const CsatModule = () => {
  const {
    heading,
    question,
    lowLabel,
    highLabel,
    commentPrompt,
    submitLabel,
    thanksMessage
  } = useModuleConfig(MODULE_KEYS.csat, CSAT_DEFAULTS)
  const { state: { pageKey } } = useMatchScreen()
  const [selectedRating, setSelectedRating] = useState<Rating | null>(null)
  const [showThanks, setShowThanks] = useState(false)
  const [hidden, setHidden] = useState(false)

  const handleRatingClick = (value: Rating) => {
    setSelectedRating(value)
    trackEvent('FeedbackModule', 'CSAT Vote', {
      page_key: pageKey,
      vote: value,
      question
    })
  }

  const handleCommentSubmit = () => {
    setHidden(true)
    setShowThanks(true)
  }

  return (
    <div className={`csat-module${hidden ? ' csat-module--hidden' : ''}`}>
      <div className="csat-module__row">
        <div className="csat-module__left">
          <h2>{heading}</h2>
          <p>{question}</p>
        </div>
        <div className="csat-module__right">
          <div className="csat-module__buttons" aria-label={`Rate on a scale from one to five, where one = ${lowLabel}, five = ${highLabel}`}>
            {RATINGS.map((value) => (
              <button
                key={value}
                onClick={() => handleRatingClick(value)}
                className={selectedRating === value ? 'csat-module__button--selected' : ''}
              >
                {value}
              </button>
            ))}
          </div>
          <div className="csat-module__labels">
            <span>{lowLabel}</span>
            <span>{highLabel}</span>
          </div>
        </div>
      </div>

      {selectedRating !== null && (
        <CsatTextarea
          question={question}
          prompt={commentPrompt}
          submitLabel={submitLabel}
          expanded
          onSubmit={handleCommentSubmit}
        />
      )}

      <div className={`csat-module__thanks${showThanks ? ' csat-module__thanks--visible' : ''}`}>
        <p>{thanksMessage}</p>
      </div>
    </div>
  )
}
